module.exports = __webpack_public_path__ + "img/Hunter-orc-m-70.0fada5c6.gif";